import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'querystringify';
import { Box, Page, Text } from '../../components';
import api from '../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default class Regions extends Component {
  constructor(props) {
    super(props);
    this.state = { regions: null };
  }

  componentDidMount() {
    const { match: { params: { carrierId } } } = this.props;
    api.getRegionsByCarrierId(qs.stringify({ limit: 100, carrierId }, true))
      .then((data) => {
        const regions = data;
        this.setState({ regions });
      });
  }

  render() {
    const { match } = this.props;
    const { regions } = this.state;

    const regionItems = (regions || []).map(region => (
      <li key={region.id}>{region.name}</li>
    ));

    return (
      <Page
        title="Regions"
        primaryAction={{ content: 'Add region', href: `${match.url}/new` }}
      >
        <ul>
          {regionItems}
        </ul>
        <Box marginTop="4em" marginBottom="4em">
          <Text as="h3">
            {`
              Regions are not really used yet, but if we decide to replace the quotes page
              then we can use them as a way to assign plans to geographic areas.
            `}
          </Text>
        </Box>
      </Page>
    );
  }
}

Regions.propTypes = propTypes;
